function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Balance-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Energie-gebouw-Energieverbruik",
  transform: "translate(-877.000000, -306.000000)",
  stroke: "#425cd4",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Filter-",
  transform: "translate(859.000000, 300.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.9138731,7 L19.1016902,15.1564444 C18.9934827,15.2887679 18.9694664,15.4735163 19.0400755,15.6304238 C19.1106846,15.7873314 19.2631741,15.8880763 19.4312934,15.8888889 L22.4564973,15.8888889 L22.4564973,23 L29.2686802,14.8435556 C29.3768877,14.7112321 29.4009039,14.5264837 29.3302949,14.3695762 C29.2596858,14.2126686 29.1071963,14.1119237 28.939077,14.1111111 L25.9138731,14.1111111 L25.9138731,7 Z",
  id: "energie-grijs"
}))));
function SvgEnergyUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "18px",
    viewBox: "0 0 13 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "energie-grijs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyUnselected);
export default __webpack_public_path__ + "static/media/Energy_unselected.bfe5da43872cfde268b738d9e32f6f45.svg";
export { ForwardRef as ReactComponent };